import state from './main/state';
import mutations from './main/mutations';
import actions from './main/actions';
import getters from "./main/getters";

import rooms from './rooms/index';
import room from './room/index';
import profiles from './profiles';
import groups from './groups';


export const chat = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
    modules: {
        rooms,
        room,
        profiles,
        groups
    }
};